<template>
  <div v-if="bannerList.length > 0">
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i @click="$parent.goNav('/hongbao')" class="grab"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />
    </div>
    <div class="appbox" v-if="appshow">
      <img class="colse" @click="appshow = false" src="/static/image/hongbaocolse.png" alt="" />
      <img class="logo" v-if="$store.state.appInfo.site_logo" :src="$store.state.appInfo.site_logo" alt="" />
      <img class="logo" v-else src="/static/image/app-logo.png" alt="" />
      <div class="testz">
        <div class="tit">{{ $store.state.appInfo.title }}app</div>
        <div class="cx">真人娱乐，体育投注，电子游艺等尽在一手掌握</div>
      </div>
      <van-button type="info" style="background: url(/static/image/btnBg.png) no-repeat; background-size: 100% 100%; font-size: 0.24rem; border: none; border-radius: 6px; height: 0.6rem" @click="$parent.goNav('/app')">立即下载</van-button>
      <!-- btnBg.png -->
    </div>
    <div style="position: relative">
      <div class="homeHeder">
        <img class="leftImg" @click="changleftshow" src="/static/image/home_muen.png" alt="" />
        <div class="rbox" @click="$parent.openKefu">
          <img src="/static/image/home_service.png" alt="" />
          客服
        </div>
      </div>
      <van-swipe @change="onChange">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.src" style="width: 100%" alt="" />
        </van-swipe-item>
        <template #indicator>
          <div class="swiper-dots">
            <div class="num">{{ current + 1 }}</div>
            <div class="sign">/</div>
            <div class="num">4</div>
          </div>
        </template>
      </van-swipe>
    </div>

    <!-- 公告 -->
    <div style="background-color: #ede9e7; padding: 6px 0 0" v-if="homenoticelis.length > 0">
      <div class="gonggao">
        <img style="width: 20px" src="/static/image/home_notice.66939586521463adbe87e2a72aa8ecad.png" alt="" />
        <div style="flex: 1">
          <van-notice-bar color="#cf866b" background="#ede9e7" scrollable
            ><span v-for="(item, index) in homenoticelis" @click="openGogao(item)" :key="index">{{ item }}</span></van-notice-bar
          >
        </div>
        <img @click="$parent.goNav('/message')" style="width: 68px" src="/static/image/home_hotsports.718f002d63ddbf2c3902907f2226a28b.png" alt="" />
      </div>
    </div>
    <!-- 公告 -->
    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />

        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}

          <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">更多公告</van-button>
        </div>
      </div>
    </div>
    <!-- 用户信息栏 -->
    <div class="xiding">
      <div class="caosuo">
        <div class="lefsg" v-if="$store.state.token">
          <div class="name">{{ $store.state.userInfo.username }}</div>
          <div class="mey"><span>￥</span>{{ $store.state.userInfo.balance }}</div>
        </div>
        <div v-else class="lefsg" @click="$parent.goNav('/login')">
          <div class="name">未登录</div>
          <div class="mey">登录后查看</div>
        </div>
        <div class="riggs">
          <div class="lisImg" @click="$parent.goNav('/recharge')">
            <img src="/static/style/feature_moneydraw.cbeb513bc9fd00ecc5372fc0e54a84c0.png" alt="" />
            存款
          </div>
          <div class="lisImg" @click="$parent.goNav('/transfer')">
            <img src="/static/style/feature_moneytransfer.bbfbe4e344c0e5f91eabadd9e20b1613.png" alt="" />
            转账
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')">
            <img src="/static/style/feature_moneysave.4b60fbaf4ee368d1e7060133f62690c9.png" alt="" />
            取款
          </div>
          <div class="lisImg" @click="$parent.goNav('/vip')">
            <img src="/static/style/feature_vip.16d90880db727a342209f4439a9b3a12.png" alt="" />
            VIP
          </div>
        </div>
      </div>
    </div>
    <!-- 热门区域 -->
    <div class="hotZone" v-if="hotList.length > 0">
      <div class="hotHead"><span class="hotDot"></span>热门游戏</div>
      <div class="hotGrid">
        <div class="hotItem" v-for="(item, index) in hotList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, item.gametype)">
          <img :src="item.gamepic" alt="" />
          <p>{{ item.gamename }}</p>
        </div>
      </div>
    </div>
    <!-- 游戏栏 -->
    <div class="gameBoxs">
      <div class="lfst">
        <div v-for="(c, ci) in categories" :key="ci" :class="activeCate == c.key ? 'ls active' : 'ls'" @click="changGameType(c.key)">
          <img :src="`/static/style/${iconMap[c.key]}_icon_${activeCate == c.key ? 'select' : 'nor'}.png`" alt="" />
          <span>{{ c.label }}</span>
        </div>
      </div>
      <div class="rigts" :class="isBannerCate ? 'bannerMode' : ''">
        <!-- 电子/捕鱼/棋牌：宽横幅美术图卡（2列） -->
        <template v-if="isBannerCate">
          <div class="vBanner" v-for="(item, index) in currentList" :key="index" @click="openVendor(item)">
            <img v-if="hasArt(item)" class="vArt" :src="bannerArt(item)" alt="" />
            <div v-else class="vComp" :class="'g_' + activeCate">
              <img class="vCompLogo" :src="xhLogo(item.platform_name)" @error="onLogoErr($event, item)" alt="" />
              <div class="vCompName">{{ item.name }}</div>
            </div>
          </div>
        </template>
        <!-- 真人/体育/电竞：保持 logo 小卡（3列） -->
        <template v-else>
          <div class="vitem" v-for="(item, index) in currentList" :key="index" @click="openVendor(item)">
            <img :src="vendorImg(item)" alt="" />
            <p>{{ item.name }}</p>
          </div>
        </template>
      </div>
    </div>

    <!-- 找到我们（防失联入口） -->
    <div class="findUs" @click="$parent.goNav('/findus')">
      <span class="findUsIco">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
      </span>
      <span class="findUsTxt">找到我们</span>
      <span class="findUsArrow"></span>
    </div>

    <!-- 服务保障 -->
    <div class="guardZone">
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg></span>
        <p>极速存取</p>
      </div>
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></svg></span>
        <p>安全加密</p>
      </div>
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg></span>
        <p>隐私保护</p>
      </div>
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-3v-8h3a2 2 0 0 1 2 2zM3 19a2 2 0 0 0 2 2h3v-8H5a2 2 0 0 0-2 2z"></path></svg></span>
        <p>7×24客服</p>
      </div>
    </div>

    <!-- 牌照合规 -->
    <div class="licenseZone">
      <div class="licTitle">牌照合规</div>
      <div class="licLogos">
        <img v-for="(p, i) in licenseLogos" :key="i" :src="xhLogo(p)" @error="onLogoHide($event)" alt="" />
      </div>
      <div class="licBadges">
        <div class="licBadge"><span class="lbCode">MO</span><div class="lbTxt"><b>澳门政府授权</b><i>MACAU AUTHORIZATION</i></div></div>
        <div class="licBadge"><span class="lbCode">MGA</span><div class="lbTxt"><b>马耳他 MGA 认证</b><i>MGA LICENSE</i></div></div>
        <div class="licBadge"><span class="lbCode">GB</span><div class="lbTxt"><b>英国 GC 监管</b><i>UK GAMBLING</i></div></div>
      </div>
      <p class="licCopy">Copyright © {{ $store.state.appInfo.title }} 版权所有</p>
    </div>

    <!-- 弹出层 -->
    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>Hi，欢迎进入{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">专属VIP体验</div>
            <p>立享会员特权</p>
            <p>享受只属于你的与众不同</p>
            <dd @click="$parent.goNav('/vip')">会员中心</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />消息中心<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />意见反馈<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />永久域名<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />关于我们<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">立即登录</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />安全退出</div>
        </div>
      </div>
    </van-popup>

    <!-- 官网弹窗 -->
    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />

          <div class="domainModal_top__1omYS">欢迎来到{{ $store.state.appInfo.title }}</div>
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      activeCate: 'concise',
      hotList: [],
      categories: [
        { key: 'concise', label: '电子' },
        { key: 'joker', label: '棋牌' },
        { key: 'fishing', label: '捕鱼' },
        { key: 'realbet', label: '真人' },
        { key: 'sport', label: '体育' },
        { key: 'gaming', label: '电竞' },
      ],
      iconMap: {
        concise: 'sidebar_slot',
        joker: 'sidebar_board',
        fishing: 'sidebar_casino',
        realbet: 'sidebar_casino',
        sport: 'sidebar_sports',
        gaming: 'sidebar_esports',
      },
      // 使用宽横幅美术图卡的分类
      bannerCates: ['concise', 'fishing', 'joker'],
      // 全部厂商统一用「品牌渐变底 + XH logo」合成横幅（运营反馈美术图偏糊，弃用）。
      // 若日后有更好的正式美术图，把 {cate}_{platform} 加回此表并放 banner_{cate}_{platform}.avif 即可自动切换。
      bannerSet: {},
      // 牌照合规展示的厂商 logo（取 XH gamelogo，加载失败自动隐藏）
      licenseLogos: ['PPS', 'PGS', 'CQ9S', 'JDBS', 'WG', 'AG', 'BBBY', 'BGBY', 'MT'],
      tanshow: true,
      appshow: true,
      goInfo: null,
    };
  },
  computed: {
    currentList() {
      return this.$store.state[this.activeCate + 'List'] || [];
    },
    isBannerCate() {
      return this.bannerCates.indexOf(this.activeCate) > -1;
    },
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
    that.getHotGames(); //获取热门子游戏
  },
  methods: {
    getHotGames() {
      let that = this;
      that.$apiFun.get('/api/hotGames', {}).then(res => {
        if (res.code == 200) {
          that.hotList = res.data || [];
        }
      });
    },
    openVendor(item) {
      this.$parent.goNav(`/gamelist?platform=${item.platform_name}&cate=${item.category_id}&title=${encodeURIComponent(item.name)}`);
    },
    vendorImg(item) {
      return item.mobile_img || item.api_logo_img || item.app_img || '';
    },
    hasArt(item) {
      return !!this.bannerSet[item.category_id + '_' + item.platform_name];
    },
    bannerArt(item) {
      return '/static/vendor/banner_' + item.category_id + '_' + item.platform_name + '.avif';
    },
    xhLogo(code) {
      return 'https://alicdn.xh-img.com/uploads/images/gamelogo/' + code + 'LOGO.webp';
    },
    onLogoErr(e, item) {
      let el = e.target;
      if (el.dataset.fb) return;
      el.dataset.fb = '1';
      el.src = this.vendorImg(item);
    },
    onLogoHide(e) {
      // 牌照合规 logo 加载失败：直接隐藏，避免破图
      e.target.style.display = 'none';
    },
    openGogao(val) {
      this.goInfo = val;
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(type) {
      this.activeCate = type;
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changappShow() {
      this.appShow = false;
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';
.domainModal_content__1nBgc {
  overflow: auto;
}
// 轮播样式
.swiper-dots {
  display: flex;
  position: absolute;
  left: 40px;
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABkCAYAAADDhn8LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTk4MzlBNjE0NjU1MTFFOUExNjRFQ0I3RTQ0NEExQjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTk4MzlBNjA0NjU1MTFFOUExNjRFQ0I3RTQ0NEExQjMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Q0E3RUNERkE0NjExMTFFOTg5NzI4MTM2Rjg0OUQwOEUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Q0E3RUNERkI0NjExMTFFOTg5NzI4MTM2Rjg0OUQwOEUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Gh5BPAAACTUlEQVR42uzcQW7jQAwFUdN306l1uWwNww5kqdsmm6/2MwtVCp8CosQtP9vg/2+/gY+DRAMBgqnjIp2PaCxCLLldpPARRIiFj1yBbMV+cHZh9PURRLQNhY8kgWyL/WDtwujjI8hoE8rKLqb5CDJaRMJHokC6yKgSCR9JAukmokIknCQJpLOIrJFwMsBJELFcKHwM9BFkLBMKFxNcBCHlQ+FhoocgpVwwnv0Xn30QBJGMC0QcaBVJiAMiec/dcwKuL4j1QMsVCXFAJE4s4NQA3K/8Y6DzO4g40P7UcmIBJxbEesCKWBDg8wWxHrAiFgT4fEGsB/CwIhYE+AeBAAdPLOcV8HRmWRDAiQVcO7GcV8CLM8uCAE4sQCDAlHcQ7x+ABQEEAggEEAggEEAggEAAgQACASAQQCCAQACBAAIBBAIIBBAIIBBAIABe4e9iAe/xd7EAJxYgEGDeO4j3EODp/cOCAE4sYMyJ5cwCHs4rCwI4sYBxJ5YzC84rCwKcXxArAuthQYDzC2JF0H49LAhwYUGsCFqvx5EF2T07dMaJBetx4cRyaqFtHJ8EIhK0i8OJBQxcECuCVutxJhCRoE0cZwMRyRcFefa/ffZBVPogePihhyCnbBhcfMFFEFM+DD4m+ghSlgmDkwlOgpAl4+BkkJMgZdk4+EgaSCcpVX7bmY9kgXQQU+1TgE0c+QJZUUz1b2T4SBbIKmJW+3iMj2SBVBWz+leVfCQLpIqYbp8b85EskIxyfIOfK5Sf+wiCRJEsllQ+oqEkQfBxmD8BBgA5hVjXyrBNUQAAAABJRU5ErkJggg==);
  background-size: 100% 100%;
}
.swiper-dots .num {
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.swiper-dots .sign {
  position: absolute;
  top: 0;
  left: 50%;
  line-height: 24px;
  font-size: 8px;
  color: #fff;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
// 主页头部标题

.homeHeder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  box-sizing: border-box;
  padding: 0 30px;
  z-index: 999;
  align-items: center;
  justify-content: space-between;
  .leftImg {
    width: 19px;
    height: 19px;
  }
  .rbox {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, sans-serif;
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #ede9e7;
  color: #cf866b;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #e6ebf6;
      color: #4e6693;
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #dfe5ff;
    border-radius: 0.4rem;
    border: 0;
    color: #4e6693;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}
.gonggao {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #cf866b;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    flex: 1;
    .name {
      font-size: 12px;
    }
    .mey {
      margin-top: 3px;
      font-size: 16px;
      font-weight: 700;
      span {
        font-size: 10px;
        font-weight: 400;
      }
    }
  }
  .riggs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .lisImg {
      width: 56px;
      text-align: center;
      font-size: 12px;
      img {
        width: 60%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
.xiding {
  background-color: #ede9e7;
  padding: 6px 0;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}

// 游戏
.gameBoxs {
  background: #ede9e7;
  -webkit-box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  box-sizing: border-box;
  padding: 10px;
  color: #cf866b;
  height: 518px;
  display: flex;
  justify-content: space-between;
  .lfst {
    width: 36px;
    height: 400px;
    background: #eff3ff;
    border-radius: 20px;
    border: 1px solid #fff;
    .ls.active {
      color: #fff;
      background: #cf866b;
    }
    .ls {
      text-align: center;
      border-radius: 20px;
      padding: 7px 0;
      img {
        width: 30px;
        display: block;
        margin: 0 auto;
      }
      span {
        font-size: 12px;
        display: block;
      }
    }
  }
  .rigts {
    flex: 1;
    overflow: auto;
    height: 420px;
    box-sizing: border-box;
    padding: 0 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
  }
}
// 热门区域
.hotZone {
  background: #ede9e7;
  padding: 8px 12px 4px;
  .hotHead {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #cf866b;
    margin-bottom: 8px;
    .hotDot {
      display: inline-block;
      width: 6px;
      height: 14px;
      border-radius: 3px;
      background: #cf866b;
      margin-right: 6px;
    }
  }
  .hotGrid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .hotItem {
      width: 23.5%;
      margin-bottom: 8px;
      cursor: pointer;
      img {
        width: 100%;
        border-radius: 10px;
        display: block;
      }
      p {
        font-size: 10px;
        color: #7a6a63;
        text-align: center;
        margin: 3px 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
// 宽横幅美术图卡（电子/捕鱼/棋牌）
.rigts.bannerMode {
  align-content: flex-start;
}
.vBanner {
  width: 48.5%;
  aspect-ratio: 1 / 1;
  margin-top: 12px;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(207, 134, 107, 0.22);
  .vArt {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .vComp {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 12px;
    .vCompLogo {
      width: 62%;
      max-height: 42%;
      object-fit: contain;
      margin-bottom: 12px;
    }
    .vCompName {
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
      white-space: nowrap;
    }
  }
  .g_concise {
    background: linear-gradient(135deg, #5b2c8a, #8a4fd0);
  }
  .g_fishing {
    background: linear-gradient(135deg, #0f6e8c, #19a7c9);
  }
  .g_joker {
    background: linear-gradient(135deg, #b5562f, #e0913c);
  }
}
// 厂商卡
.vitem {
  width: 31%;
  margin-top: 12px;
  cursor: pointer;
  background: #fff;
  border-radius: 12px;
  padding: 12px 6px 8px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(207, 134, 107, 0.18);
  img {
    width: 72%;
    display: block;
    margin: 0 auto;
  }
  p {
    text-align: center;
    font-size: 11px;
    color: #7a6a63;
    margin: 8px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
// app下载
.appbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.8rem;
  box-sizing: border-box;
  padding-right: 15px;
  .colse {
    width: 0.4rem;
    margin-left: 0.1rem;
  }
  .logo {
    width: 1rem;
    margin: 0 0.2rem;
  }
  .testz {
    flex: 1;
    .tit {
      font-size: 0.23rem;
      font-weight: 700;
    }
    .cx {
      font-size: 0.2rem;
      color: #ccc;
    }
  }
}
// 找到我们
.findUs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 14px 12px 0;
  height: 48px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 2px 10px rgba(207, 134, 107, 0.16);
  cursor: pointer;
  .findUsIco {
    width: 20px;
    height: 20px;
    color: #cf866b;
    margin-right: 8px;
    display: inline-flex;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  .findUsTxt {
    font-size: 16px;
    font-weight: 700;
    color: #4a3a34;
    letter-spacing: 1px;
  }
  .findUsArrow {
    width: 8px;
    height: 8px;
    border-top: 2px solid #c4a79c;
    border-right: 2px solid #c4a79c;
    transform: rotate(45deg);
    margin-left: 10px;
  }
}
// 服务保障
.guardZone {
  display: flex;
  justify-content: space-between;
  margin: 14px 12px 0;
  padding: 14px 6px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(207, 134, 107, 0.1);
  .guardItem {
    flex: 1;
    text-align: center;
    .guardIco {
      display: inline-flex;
      width: 30px;
      height: 30px;
      color: #cf866b;
      svg {
        width: 100%;
        height: 100%;
      }
    }
    p {
      font-size: 11px;
      color: #7a6a63;
      margin: 6px 0 0;
    }
  }
}
// 牌照合规
.licenseZone {
  margin: 14px 12px 76px;
  padding: 16px 12px 18px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(207, 134, 107, 0.1);
  .licTitle {
    font-size: 15px;
    font-weight: 700;
    color: #4a3a34;
    margin-bottom: 12px;
  }
  .licLogos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 4px;
    border-bottom: 1px solid #f0ebe8;
    img {
      height: 20px;
      width: auto;
      object-fit: contain;
      margin: 0 14px 12px 0;
      filter: grayscale(25%);
    }
  }
  .licBadges {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    .licBadge {
      width: 32%;
      display: flex;
      align-items: center;
      background: #f6f2f0;
      border-radius: 8px;
      padding: 8px 6px;
      box-sizing: border-box;
      .lbCode {
        font-size: 14px;
        font-weight: 800;
        color: #b98b78;
        margin-right: 5px;
        white-space: nowrap;
      }
      .lbTxt {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        b {
          font-size: 10px;
          color: #5a4a44;
          white-space: nowrap;
        }
        i {
          font-size: 7px;
          color: #b3a7a1;
          font-style: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .licCopy {
    text-align: center;
    font-size: 11px;
    color: #b3a7a1;
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue